import React, { useState, useEffect, useCallback } from 'react'
import api from './api'
import Login from './Login'

function WrongNotebookReview() {
  const [isLogin, setIsLogin] = useState(false)
  const [currentUser, setCurrentUser] = useState(null)
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [testMode, setTestMode] = useState(false)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [userInput, setUserInput] = useState('')
  const [feedback, setFeedback] = useState('')
  const [isCorrect, setIsCorrect] = useState(null)
  const [testResults, setTestResults] = useState({ correct: 0, incorrect: 0 })
  const [showEnglish, setShowEnglish] = useState(false)

  const checkLogin = useCallback(async () => {
    const token = localStorage.getItem('accessToken')
    if (!token) {
      setIsLogin(false)
      setCurrentUser(null)
      return
    }
    try {
      const user = await api.getUserInfo()
      setCurrentUser(user)
      setIsLogin(true)
    } catch (e) {
      api.logout()
      setIsLogin(false)
      setCurrentUser(null)
    }
  }, [])

  useEffect(() => {
    checkLogin()
  }, [checkLogin])

  const fetchCandidates = useCallback(async () => {
    if (!isLogin) return
    setLoading(true)
    setError('')
    try {
      const data = await api.getWrongNotebookReviewCandidates()
      setItems(Array.isArray(data) ? data : [])
    } catch (e) {
      setError(e.message)
      setItems([])
    } finally {
      setLoading(false)
    }
  }, [isLogin])

  useEffect(() => {
    if (isLogin) fetchCandidates()
  }, [isLogin, fetchCandidates])

  const startTest = () => {
    if (!items.length) return
    setTestMode(true)
    setCurrentIndex(0)
    setUserInput('')
    setFeedback('')
    setIsCorrect(null)
    setTestResults({ correct: 0, incorrect: 0 })
  }

  const resetTest = () => {
    setTestMode(false)
    setCurrentIndex(0)
    setUserInput('')
    setFeedback('')
    setIsCorrect(null)
    setShowEnglish(false)
  }

  const checkAnswer = async () => {
    if (!items.length) return
    const current = items[currentIndex]
    const ok = userInput.trim().toLowerCase() === String(current.vocabulary_english || '').toLowerCase()
    setIsCorrect(ok)
    setFeedback(ok ? '正确' : `错误，正确答案：${current.vocabulary_english}`)
    const vocabId = current.vocabulary
    const errCount = ok ? 0 : 1
    try {
      await api.reportTestResult(vocabId, errCount)
      setTestResults(prev => ({ correct: prev.correct + (ok ? 1 : 0), incorrect: prev.incorrect + (ok ? 0 : 1) }))
    } catch (e) {
      setError(e.message)
    }
  }

  const nextItem = () => {
    if (!items.length) return
    if (currentIndex < items.length - 1) {
      setCurrentIndex(i => i + 1)
      setUserInput('')
      setFeedback('')
      setIsCorrect(null)
      setShowEnglish(false)
    }
  }

  if (!isLogin) {
    return (
      <div className="login-container">
        <h2>请先登录</h2>
        <Login onLogin={(u) => { setCurrentUser(u); setIsLogin(true) }} />
      </div>
    )
  }

  if (loading) return <div className="loading">加载中...</div>
  if (error) return <div className="error">{error}</div>

  return (
    <div className="container">
      <div className="user-info">
        <span>欢迎，{currentUser.username}</span>
      </div>
      <h2>错题复习</h2>
      {!testMode && (
        <div style={{ marginBottom: '20px' }}>
          <span>待复习：{items.length} 条</span>
          <button onClick={startTest} disabled={!items.length} style={{ marginLeft: '10px', padding: '8px 15px' }}>开始复习</button>
        </div>
      )}
      {testMode && items.length > 0 && (
        <div className="vocab-card">
          <div style={{ marginBottom: '10px' }}>
            <span>进度：{currentIndex + 1}/{items.length}</span>
            <button onClick={resetTest} style={{ marginLeft: '10px', padding: '6px 12px' }}>结束</button>
          </div>
          <div style={{ margin: '10px 0', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '4px', textAlign: 'center', cursor: 'pointer' }} onClick={() => setShowEnglish(s => !s)}>
            {items[currentIndex].vocabulary_chinese}
            {showEnglish && (
              <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#e3f2fd', borderRadius: '4px' }}>
                {items[currentIndex].vocabulary_english}
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px', justifyContent: 'center' }}>
            <button
              onClick={async () => {
                const url = items[currentIndex].pronunciation_url
                if (!url) return
                try {
                  const audio = new Audio(url)
                  await audio.play()
                } catch (e) {}
              }}
              disabled={!items[currentIndex].pronunciation_url}
              style={{ padding: '8px 15px' }}
            >播放发音</button>
          </div>
          <div className="input-area">
            <input type="text" value={userInput} onChange={(e) => setUserInput(e.target.value)} placeholder="请输入英文..." style={{ marginRight: '10px', padding: '8px', borderRadius: '4px', border: '1px solid #ddd' }} />
            <button onClick={checkAnswer} style={{ padding: '8px 15px' }}>确认</button>
          </div>
          {feedback && (
            <div className={`feedback ${isCorrect ? 'correct' : 'wrong'}`} style={{ marginTop: '10px' }}>{feedback}</div>
          )}
          <div className="nav-buttons" style={{ marginTop: '10px' }}>
            <button onClick={nextItem} disabled={currentIndex >= items.length - 1}>下一个</button>
          </div>
        </div>
      )}
      {!testMode && items.length === 0 && (
        <div className="no-data">暂无需要复习的错题</div>
      )}
      {testMode && (
        <div className="test-results" style={{ marginTop: '20px' }}>
          <div>正确: {testResults.correct} 错误: {testResults.incorrect}</div>
        </div>
      )}
    </div>
  )
}

export default WrongNotebookReview